/**
 * Health Monitor Slider - single slider with image + title + content per slide, custom dot pagination
 */
if (!customElements.get('health-monitor-slider')) {
  customElements.define(
    'health-monitor-slider',
    class HealthMonitorSlider extends HTMLElement {
      constructor() {
        super();
        this.slider = null;
      }

      connectedCallback() {
        this.swiperEl = this.querySelector('.health-monitor-slider__slider');
        this.dots = this.querySelectorAll('.health-monitor-slider__dot');
        this.arrows = this.querySelector('.health-monitor-slider__arrows');
        this.enableSlider = this.dataset.enableSlider === 'true';

        if (!this.enableSlider || !this.swiperEl) return;

        this.initSlider();
        this.bindDots();
      }

      initSlider() {
        const prevBtn = this.arrows?.querySelector('.swiper-button-prev');
        const nextBtn = this.arrows?.querySelector('.swiper-button-next');

        const sliderOptions = {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: true,
          allowTouchMove: true,
          navigation: prevBtn && nextBtn ? {
            prevEl: prevBtn,
            nextEl: nextBtn,
          } : false,
          on: {
            init: (swiper) => this.updateDots(swiper.realIndex),
            slideChange: (swiper) => this.updateDots(swiper.realIndex),
          },
        };

        this.slider = new window.FoxTheme.Carousel(this.swiperEl, sliderOptions);
        this.slider.init();
      }

      updateDots(activeIndex) {
        this.dots?.forEach((dot, i) => {
          dot.classList.toggle('health-monitor-slider__dot--active', i === activeIndex);
        });
      }

      bindDots() {
        this.dots?.forEach((dot) => {
          dot.addEventListener('click', () => {
            const index = parseInt(dot.dataset.dotIndex ?? '0', 10);
            this.slider?.slider?.slideToLoop?.(index);
            this.updateDots(index);
          });
        });
      }

      disconnectedCallback() {
        this.slider?.slider?.destroy?.();
      }
    }
  );
}
